import Cookies from "js-cookie"

export enum CookieCategory {
  NECESSARY = "necessary",
  PREFERENCES = "preferences",
  ANALYTICS = "analytics",
  MARKETING = "marketing",
}

export interface CookieConsent {
  consentDate?: string
  necessary: boolean
  preferences: boolean
  analytics: boolean
  marketing: boolean
}

export const defaultConsent: CookieConsent = {
  necessary: true,
  preferences: false,
  analytics: false,
  marketing: false,
}

const CONSENT_COOKIE_NAME = "cookie_consent"

export const saveConsent = (consent: CookieConsent): void => {
  const consentToSave = { ...consent, consentDate: new Date().toISOString() }
  Cookies.set(CONSENT_COOKIE_NAME, JSON.stringify(consentToSave), {
    expires: 365,
  })
}

export const getConsent = (): CookieConsent => {
  const cookie = Cookies.get(CONSENT_COOKIE_NAME)
  if (cookie) {
    try {
      const parsed = JSON.parse(cookie)
      return { ...defaultConsent, ...parsed, necessary: true }
    } catch (e) {
      return { ...defaultConsent, consentDate: undefined }
    }
  }
  return { ...defaultConsent, consentDate: undefined }
}

export const setCookieWithConsent = (
  name: string,
  value: string,
  category: CookieCategory,
  options?: Cookies.CookieAttributes
): boolean => {
  const consent = getConsent()
  if (category === CookieCategory.NECESSARY || consent[category]) {
    Cookies.set(name, value, options)
    return true
  }
  return false
}

export const getCookie = (name: string): string | undefined => {
  return Cookies.get(name)
}

export const removeCookie = (
  name: string,
  options?: Cookies.CookieAttributes
): void => {
  Cookies.remove(name, options)
}

export const clearNonEssentialCookies = (): void => {
  const allCookies = Cookies.get()
  const essentialCookies = [
    CONSENT_COOKIE_NAME,
    "connect.sid",
    "_medusa_session",
  ]

  for (const cookieName in allCookies) {
    if (!essentialCookies.includes(cookieName)) {
      Cookies.remove(cookieName)
    }
  }
} 